import { render, staticRenderFns } from "./InspectionList.vue?vue&type=template&id=11887348&scoped=true&"
import script from "./InspectionList.vue?vue&type=script&lang=js&"
export * from "./InspectionList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionList.vue?vue&type=style&index=0&id=11887348&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11887348",
  null
  
)

export default component.exports